import styled from 'styled-components';

const VideosListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;
  background-color: var(--gray-lighter);
  border-radius: 4px;

  @media screen and (max-width: 640px) {
    width: 100%;
  }
`;

const TitleAndAutoPlayToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
`;

const ContentList = styled.div`
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  padding-bottom: 16px;
  overflow-y: auto;
`;

const VideosTitle = styled.h4``;

export {
  VideosListContainer,
  TitleAndAutoPlayToggleContainer,
  ContentList,
  VideosTitle,
};
